.biel-search-ask-ai-container.selected {
    background-color: var(--biel-search-result-bg-hover-color);
}

.biel-search-ask-ai__title {
    font-size: 18px;
    margin-bottom: 5px;
    color: var(--biel-search-result-title-color);
    margin-top: 0;
}

.biel-search-ask-ai__description {
    color: var(--biel-search-result-description-color);
    margin: 0;
}

.biel-search-ask-ai-text-container {
    display: flex;
    flex-direction: column;
    margin-left: 14px;
}

.biel-search-ask-ai-container {
    border: 1px solid var(--biel-search-result-border-color);
    border-radius: 6px;
    background-color: var(--biel-search-result-bg-color);
    transition: background-color 0.3s ease;
    padding: 10px 8px;
    display: flex;
    align-items: flex-start;
    align-items: center;
}

.biel-search-ask-ai-icon {
    background: var(--biel-search-ask-ai-bg-color);
    border: var(--biel-search-ask-ai-bg-color);
    border-radius: 8px;
    color: var(--biel-search-ask-ai-color);
    padding: 6px;
    display: flex;
}

.biel-search-ask-ai {
    cursor: pointer;
}